import Vue from 'vue'
import injector from 'vue-inject'

require('../../start')

Vue.use(injector)

let api = injector.get('api')
let status = injector.get('status')

const state = {
    lastLogin: null,
    mobileMenu: false,
    otp: 0,
    verificationFiles: [],
    settings: {},
    temporarySettings: false
}

const getters = {

    mobileMenu: state => {
        return state.mobileMenu
    },

    otp: state => {
        return state.otp
    },

    verificationFiles: state => {
        return state.verificationFiles
    },

    /**
     * Get user's settings
     * @param state
     * @returns {state.settings|{confirmations, notifications}}
     */
    settings: state => {
        return state.settings
    },

    /**
     * Get user's temporary settings
     * @param state
     * @returns {state.temporarySettings|{confirmations, notifications}}
     */
    temporarySettings: state => {
        return state.temporarySettings
    },
}

const mutations = {
    /**
     * Set settings in store
     * @param state
     * @param response
     */
    setSettings (state, response) {
        let data = response.data.settings,
            settingsData = {
                confirmations: {
                    twoStepLogin: data.filter(function( obj ) {
                        return obj.name === 'TWO_STEP_LOGIN_VERIFICATION'
                    })[0],
                    payouts: data.filter(function( obj ) {
                        return obj.name === 'TWO_STEP_PAYOUT_VERIFICATION'
                    })[0],
                }
            }
        Vue.set(state, 'settings', settingsData)
    },

    /**
     * Set new setting - temporary settings before save
     */
    setTemporarySetting (state, params) {
        if (!state.temporarySettings) {
            state.temporarySettings = {}
        }
        Vue.set(state.temporarySettings, params.id, params)
    },

    /**
     * Reset temporary settings list
     * @param state
     */
    resetTemporarySettings (state) {
        Vue.set(state, 'temporarySetting', false)
    },

    /**
     * Set security config in store
     * @param state
     * @param data
     */
    setOtp (state, data) {
        Vue.set(state, 'otp', data)
    },

    /**
     * Set verification images in store
     * @param state
     * @param data
     */
    setVerificationFiles (state, data) {
        Vue.set(state, 'verificationFiles', data)
    },

    /**
     * Toggle mobile menu
     * @param state
     */
    toggleMobileMenu (state) {
        let toggle = !this.getters.mobileMenu
        Vue.set(state, 'mobileMenu', toggle)
    },

    /**
     * Off mobile menu
     * @param state
     */
    offMobileMenu (state) {
        Vue.set(state, 'mobileMenu', false)
    }
}

const actions = {
    async loadLoginHistory ({ commit }) {
        Vue.http.get(api.history(1,8)).then(response => {
            commit('setLoginHistory', response.data.data.results)
        }, error => {
            status['status' + error.status]()
        })
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/settings.js